// extracted by mini-css-extract-plugin
export default {"icon":"Homepage_icon__FUY6J"};